import React from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { Modal, Icon, Button, Form, Message } from "semantic-ui-react";
import { save } from '../../actions/authentication';
import LabelledButton from '../LabelledButton/LabelledButton';
import { addMaterial } from '../../actions/materials';

const inlineStyle = {
  modal: {
    marginTop: "25px !important",
    marginLeft: "auto",
    marginRight: "auto"
  },
  field: {
    marginTop: '10px'
  }
};

class AddMaterial extends React.Component {

  state = {
    open: false,
    name: '',
    shortname: '',
    nameError: false
  };

  handleInputChange = (field, e) => {
    let state = this.state;
    state[field] = e.target.value;

    this.setState(state, () => {this.validateInput()});
  };

  handleModal = open => {
    let state = {
      open: open,
      name: '',
      shortname: '',
      nameError: false
    };

    this.setState(state);
  };

  validateInput = () => {
    const { 
      name
    } = this.state;

    const tmpState = {
      nameError: false
    };

    if (!name)
      tmpState.nameError = true;

    const isValid = !Object.values(tmpState).includes(true);

    this.setState({
      ...tmpState
    });

    return isValid;
  }

  handlePositive = async (state) => {
    const isValid = this.validateInput();
    if (!isValid)
      return;

    const { authenticated, save } = this.props;

    let data = JSON.parse(JSON.stringify(state));
    delete data.open;

    await this.props.addMaterial(data);
    await this.handleModal(false);

    if (authenticated)
      await save();
  }

  render() {

    const { t } = this.props;
    const { open } = this.state;
    const { nameError } = this.state;
    
    return(
      <Modal
        style={inlineStyle.modal}
        open={open}
        closeIcon={false}
        closeOnDimmerClick={false}
        onClose={() => this.handleModal(false)}
        trigger={
          <Button
            content={t("material.newmaterial.buttontitle")}
            icon="plus"
            onClick={() => this.handleModal(true)}
          />
        }
      >
        <Modal.Header>{t("material.newmaterial.header")}</Modal.Header>
        <Modal.Content>
          <Form.Group>
            <Form.Input 
              label={t("material.name")} 
              placeholder={t("material.name")} 
              value={this.state.name}
              onChange={(e) => this.handleInputChange('name', e)}
              fluid
            />

            {nameError && 
              <Message negative>
                <Message.Header>{t("general.errormessages.name_missing_error")}</Message.Header>
                <p></p>
              </Message> 
            }
            
          </Form.Group>  
          <Form.Group style={inlineStyle.field}>
            <Form.Input 
              label={t("material.shortname")} 
              placeholder={t("material.shortname")} 
              value={this.state.shortname}
              onChange={(e) => this.handleInputChange('shortname', e)}
              fluid
            />
          </Form.Group>                
        </Modal.Content>
        <Modal.Actions>
          <Button.Group>
            <Button
              type="button"
              onClick={() => this.handleModal(false)}
              color="grey"
            >
              <Icon name="close" />
              {t("buttons.cancel")}
            </Button>
            <Button type="button" onClick={_ => this.handlePositive(this.state)} color="green">
              <Icon name="checkmark" />
              {t("buttons.ok")}
            </Button>
          </Button.Group>
        </Modal.Actions>
      </Modal>
    );
  }
}

const AddMaterial_i18nWrapper = withNamespaces('translation')(AddMaterial);

function mapStateToProps(state) {
  const authenticated = state.auth.authenticated;
  return {
    authenticated
  };
}

export default connect(mapStateToProps, {addMaterial, save})(AddMaterial_i18nWrapper);